import { render, staticRenderFns } from "./OwnersListCard.vue?vue&type=template&id=1dd8f518&scoped=true"
import script from "./OwnersListCard.vue?vue&type=script&lang=js"
export * from "./OwnersListCard.vue?vue&type=script&lang=js"
import style0 from "./OwnersListCard.vue?vue&type=style&index=0&id=1dd8f518&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd8f518",
  null
  
)

export default component.exports